import { FC } from "react";
import { useIntl } from "react-intl";
import { appointmentService } from "../../../../../types/calendar";
import { Button, Select } from "antd";
import { deleteIconSVG, serviceSVG } from "../../../../../assets/SVGs/SVGs";
import { useQuery } from "@tanstack/react-query";
import { getAllServices } from "../../../../../network/service";
import { service } from "../../../../../types/service";

interface ServicesProps {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  services: appointmentService[];
  setServices: (services: appointmentService[]) => void;
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  locationId: number | null;
  removeServicesItem: (index: number) => void;
  getTeamMembersOptions: (id: number, type: "service" | "package") => any;
  handleSelectTeamMember: (
    id: number,
    teamMemberId: number | "lookfindr",
    type: "service" | "package"
  ) => void;
}

const Services: FC<ServicesProps> = ({
  services,
  setServices,
  removeServicesItem,
  handleSelectTeamMember,
  locationId,
  step,
  setStep,
  setSearchValue,
  searchValue,
  getTeamMembersOptions,
}) => {
  const intl = useIntl();
  const { data } = useQuery(
    ["services", searchValue],
    () => getAllServices(locationId, searchValue),
    {
      enabled: !!locationId,
    }
  );
  const servicesOptions = Array.isArray(data?.data)
    ? data?.data
        ?.map((service: service) => {
          return service?.pricing_options?.map((option) => {
            if (
              services.find(
                (s: {
                  id: number;
                  service_id: number;
                  price: string;
                  duration: string;
                }) => s.id === option.id && s.service_id === option.service_id
              )
            ) {
              return {
                label: (
                  <div
                    className="flex justify-between p-1"
                    key={service?.id + " " + option?.id}
                  >
                    <p className="capitalize">{service?.name}</p>
                    <p>
                      {" "}
                      {option?.price}
                      <span className="mx-1 text-xs text-gray-500">
                        {intl.formatMessage({
                          id: "SAR",
                        })}{" "}
                      </span>
                    </p>
                    <p>
                      {option?.duration}
                      <span className="mx-1 text-xs text-gray-500">
                        {intl.formatMessage({
                          id: "minutes",
                          defaultMessage: "دقيقة",
                        })}{" "}
                      </span>
                    </p>
                  </div>
                ),
                value: option?.id + " " + service?.id,
                key: option?.id + " " + service?.id,
                disabled: true,
              };
            } else {
              return {
                label: (
                  <div
                    className="flex justify-between p-1"
                    key={service?.id + " " + option?.id}
                  >
                    <p className="capitalize">{service?.name}</p>
                    <p>
                      {" "}
                      {option?.price}
                      <span className="mx-1 text-xs text-gray-500">
                        {intl.formatMessage({
                          id: "SAR",
                          defaultMessage: "ريال سعودي",
                        })}{" "}
                      </span>
                    </p>
                    <p>
                      {option?.duration}
                      <span className="mx-1 text-xs text-gray-500">
                        {intl.formatMessage({
                          id: "minutes",
                          defaultMessage: "دقيقة",
                        })}{" "}
                      </span>
                    </p>
                  </div>
                ),
                value: option?.id + " " + service?.id,
                key: option?.id + " " + service?.id,
              };
            }
          });
        })
        ?.flat()
    : [];
  const handleAddService = (value: string) => {
    const [id, service_id] = value.split(" ");
    const parentService: service = data?.data?.find(
      (service: service) => service.id === parseInt(service_id)
    );
    if (!parentService) return;
    const childService = parentService?.pricing_options?.find(
      (option) => option.id === parseInt(id)
    );
    if (!childService) return;

    const newServices: {
      id: number;
      name: string;
      service_id: number;
      price: string;
      duration: string;
    }[] = [
      ...services,
      {
        id: parseInt(id),
        name: parentService.name,
        service_id: childService?.service_id,
        price: childService.price,
        duration: childService.duration,
      },
    ];
    setServices(newServices);
  };
  return (
    <div className="flex flex-col gap-2 w-full max-h-[300px] overflow-auto">
      <p className="text-gray-500 text-sm min-h-[30px]">
        {" "}
        {intl.formatMessage({
          // id: "selectedServicesAndPackages",
          id: "selectedServices",
        })}
      </p>
      {step === 1 ? (
        <div className="my-2 ">
          <Select
            className="w-full"
            onSearch={(value) => {
              setSearchValue(value);
            }}
            onChange={(value) => {
              handleAddService(value);
              if (value && searchValue) {
                setSearchValue("");
              }
            }}
            showSearch
            placeholder={intl.formatMessage({
              id: "selectServices",
            })}
            filterOption={false}
            options={servicesOptions}
          />
        </div>
      ) : null}
      {services.map((service, index) => {
        return (
          <div className="bg-[rgb(251,251,255)] p-2 ">
            <div className="flex gap-2  justify-between rounded" key={index}>
              <p className="flex gap-1 items-center">
                <span>{serviceSVG}</span>
                <span>{service.name}</span>
              </p>
              <p className="flex gap-1 items-center ">
                <span>{service?.duration}</span>
                <small className="text-xs self-center mt-2">
                  {" "}
                  {intl.formatMessage({
                    id: "minutes",
                    defaultMessage: "دقيقة",
                  })}
                </small>
              </p>
              <p className="flex gap-1 items-center ">
                <span>{service?.price}</span>
                <small className="text-xs self-center mt-2">
                  {intl.formatMessage({
                    id: "SAR",
                    defaultMessage: "ريال سعودي",
                  })}
                </small>
              </p>
              {step < 4 ? (
                <Button
                  type="text"
                  htmlType="button"
                  onClick={() => {
                    removeServicesItem(index);
                  }}
                >
                  {deleteIconSVG}
                </Button>
              ) : null}
            </div>
            {step > 1 ? (
              <div className="rounded-select mt-3">
                <Select
                  notFoundContent={
                    <p className="text-red-700 p-2 font-semibold text-center">
                      {intl.formatMessage({
                        id: "selectTeamMemberWarningTextService",
                        defaultMessage:
                          "لا يوجد عضو متاح في هذا الوقت لهذه الخدمات يرجى تغيير الوقت",
                      })}
                    </p>
                  }
                  placeholder={intl.formatMessage({
                    id: "selectTeamMember",
                    defaultMessage: "اختر عضو الفريق",
                  })}
                  onChange={(id) => {
                    handleSelectTeamMember(
                      service?.id,
                      id as number | "lookfindr",
                      "service"
                    );
                  }}
                  className="  w-full rounded-full !bg-[#EEF0FF] h-12 "
                  options={getTeamMembersOptions(
                    service?.service_id,
                    "service"
                  )}
                />
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default Services;
